// Components==============
import indexSkill from 'actions/skill/index';
import Dropdown from 'components/UI/Dropdown/Dropdown';
import { useRedux } from 'hooks/useRedux';
import { useReduxAction } from 'hooks/useReduxAction';
import React, { useContext, useEffect, useState } from 'react';
import { FilterType, TranslateType } from 'typings';
import { FilterContext } from '../../FilterMenu';
// =========================

export default function SkillDropdown({
  initialText,
  id,
}: {
  initialText: TranslateType;
  id: number;
}) {
  const { setFilterValues, triggerReset } = useContext(FilterContext);
  const dispatch = useReduxAction();

  const [selected, setSelected] = useState<string[]>([]);

  useEffect(() => {
    dispatch(indexSkill());
  }, []);

  const skills = useRedux((state) =>
    state.skill?.entities.allIds.map(
      (skillId) => state.skill?.entities.byId[skillId]
    )
  );

  const options = skills?.map((skill) => (skill?.name ? skill?.name : ''));

  useEffect(() => setSelected([]), [triggerReset]);

  useEffect(() => {
    const newValue = skills
      ?.filter((skill) =>
        skill?.name ? selected.includes(skill?.name) : false
      )
      .map((skill) => skill?.id);

    setFilterValues(
      (prev) =>
        prev.map((val) =>
          val.id === id ? { ...val, value: newValue } : val
        ) as FilterType[]
    );
  }, [selected]);

  return (
    <Dropdown
      initialText={initialText}
      selectedItems={selected}
      setSelectedItems={setSelected}
      initialOptions={options || []}
    />
  );
}
